import { useMemo, useState } from "react";
import { ExpandedLocalDetails } from "../../samples/@types/expanded_local_details";
import { DetectionCounts } from "../differenceMatrixFields";
import CompareTable from "./CompareTable";
import CompareToolbar from "./CompareToolbar";
import SampleCard from "./SampleCard";
import { buildCompareRows, countDifferences } from "./utils";
import styles from "./compare-samples.module.scss";

interface CompareSamplesBodyProps {
  main: ExpandedLocalDetails;
  compared: ExpandedLocalDetails;
  detections: { main?: DetectionCounts; other?: DetectionCounts };
}

/** Takes both payloads loaded, so it never renders a half comparison. */
const CompareSamplesBody = ({
  main,
  compared,
  detections
}: CompareSamplesBodyProps): JSX.Element => {
  const [onlyDifferences, setOnlyDifferences] = useState(false);
  const rows = useMemo(
    () => buildCompareRows(main, compared, detections),
    [main, compared, detections]
  );

  return (
    <>
      <div className={styles.subtitle}>
        Local sample against the main sample of this similarity group
      </div>
      <div className={styles.cards}>
        <SampleCard role="Main sample" details={main} />
        <SampleCard role="Compared sample" details={compared} />
      </div>
      <CompareToolbar
        differenceCount={countDifferences(rows)}
        fieldCount={rows.length}
        onlyDifferences={onlyDifferences}
        onOnlyDifferencesChange={setOnlyDifferences}
      />
      <CompareTable
        rows={onlyDifferences ? rows.filter(row => row.differs) : rows}
      />
    </>
  );
};

export default CompareSamplesBody;
